import React, { useEffect } from "react";
// import Box from "@mui/material/Box";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import FdTextField from "../UIComponents/TextField/FdTextfield";

interface OptionType {
  label: string;
  inputValue?: string;
  value?: number;
}

export interface IProps {
  label: string;
  options: OptionType[];
  initialValue: OptionType | null;
  onValueChange: Function;
  name: string;
}

const filter = createFilterOptions();

const ComboDropdown = ({
  label,
  options,
  initialValue,
  onValueChange,
  name,
}: IProps) => {
  const [value, setValue] = React.useState<OptionType | null>(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue, options]);

  return (
    <>
      <Autocomplete
        value={value}
        onChange={(event, newValue: any) => {
          if (typeof newValue === "string") {
            setValue({
              label: newValue,
            });
            onValueChange(newValue);
          } else if (newValue && newValue.inputValue) {
            // Create a new value from the user input
            setValue({
              label: newValue.inputValue,
            });
            onValueChange(newValue);
          } else {
            setValue(newValue);
            onValueChange(newValue);
          }
        }}
        filterOptions={(options: any, state: any) => {
          const filtered = filter(options, state);

          const isExisting = options.some(
            (option: any) => state.inputValue === option.label
          );
          // Suggest the creation of a new value
          if (state.inputValue !== "" && !isExisting) {
            filtered.push({
              inputValue: state.inputValue,
              label: `Add "${state.inputValue}"`,
            });
          }

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        id="free-solo-with-text-demo"
        options={options}
        getOptionLabel={(option: any) => {
          // Value selected with enter, right from the input
          if (typeof option === "string") {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.label;
        }}
        renderOption={(props: any, option: any) => (
          <li {...props}>{`${option.label}`}</li>
        )}
        freeSolo
        renderInput={(params) => (
          <FdTextField name={name} {...params} label={label} />
        )}
      />
    </>
  );
};

export default ComboDropdown;
